import { useState } from "react";
import { useParams } from "react-router-dom";
import Button, { BUTTON_TYPE_CLASSES } from "../../button/button.component";
import Image, { IMAGE_TYPE } from "../../image/image.component";
import {
  CMHeadingContainer,
  CMOrderDetails,
  CMBox,
  CMOffer,
  CMDisclaimer,
  CMDisBox,
  CMImage,
  CMOfferButton,
} from "./confirm-order.styles";
import {
  formatCommaNumbers,
  getTotalValue,
  toFix,
} from "../../../Utils/common.utils";
import { createOrderApi } from "../../../Services/prod/auth.service";
import { toast } from "react-toastify";
import "./ConfirmOrder.scss";

const ConfirmOrder = ({
  handleNext,
  handlePrev,
  editValues,
  auction,
  pairBalance,
  pairFees,
  update,
  setUpdate,
  setActiveStep,
  setOrderTotal,
}) => {
  const [disabled, setDisabled] = useState(false);
  const createOrder = async () => {
    try {
      setDisabled(true);
      const createOrderPayload = {
        ...(auction?.symbol && { pairName: `${auction.symbol}_USD` }),
        ...(editValues?.stop && { trigger_price: Number(editValues.stop) }),
        ...(editValues?.price && { price: Number(editValues.price) }),
        ...(editValues?.quantity && { quantity: Number(editValues.quantity) }),
        ...(editValues?.selectedOption && {
          side: editValues.selectedOption === "Buy" ? 0 : 1,
        }),
        ...(editValues?.selectedPriceOption && {
          type:
            editValues.selectedPriceOption === "Limit"
              ? 0
              : editValues.selectedPriceOption === "Market"
              ? 1
              : 2,
        }),
      };

      const createOrderRes = await createOrderApi(createOrderPayload);
      if (createOrderRes?.status === 200) {
        // toast.success(createOrderRes?.message);

        setUpdate(!update);
        handleNext(editValues);
        // setActiveStep((value) => value + 1);
        setOrderTotal(
          getTotalValue(
            Number(editValues?.price || pairFees?.last_price),
            Number(editValues?.quantity) *
              (1 +
                (editValues?.selectedOption === "Buy"
                  ? pairFees?.trade_fee_buy
                  : pairFees?.trade_fee_sell) /
                  100)
          ).toFixed(2)
        );

        // handleClose();
      } else {
        setDisabled(false);
        toast.error(createOrderRes?.message, {
          autoClose: 10000, // display for 5 seconds (default is 5000ms)
          position: "top-center", // or "bottom-center" as per your preference
        });
        // toast.error(createOrderRes?.message);
      }
    } catch (error) {
      setDisabled(false);
      toast.error(error?.message, {
        autoClose: 10000, // display for 5 seconds (default is 5000ms)
        position: "top-center", // or "bottom-center" as per your preference
      });
      // toast.error(error?.message);
    }
  };
  return (
    <div className="CMMainDiv confirm-order">
      <CMHeadingContainer>
        <h3>
          Trading Symbol / <span>{auction?.symbol}</span>
        </h3>
      </CMHeadingContainer>

      <CMOrderDetails className="d-flex align-items-center pt-2">
        <div className="image-column">
          <Image
            src={
              auction.imgSrc && auction.imgSrc.length > 0
                ? auction.imgSrc[0]
                : ""
            }
            imageType={IMAGE_TYPE.rounded}
            alt={auction.title}
            width={"100%"}
            height={"auto"}
          />{" "}
        </div>
        <div className="text-column">
          <h5>{auction.symbolType}</h5>
          <h1>{auction.assetName}</h1>
        </div>
      </CMOrderDetails>

      <CMBox className="py-4 px-4 px-lg-4 box-sizing">
        <span>
          Available -{" "}
          {editValues?.selectedOption === "Buy"
            ? formatCommaNumbers(toFix(pairBalance?.USD, 2))
            : formatCommaNumbers(
                toFix(pairBalance[auction?.symbol?.toUpperCase()], 2)
              )}
        </span>{" "}
        <span style={{ fontWeight: "bold" }}>
          {editValues?.selectedOption === "Buy"
            ? "USD"
            : auction?.symbol?.toUpperCase()}
        </span>
        <div className="container px-2 pt-2">
          <div className="row pb-4">
            <div className="column">
              <div className="action-column">
                <div className="label-column">
                  <label htmlFor="action-txtInput">Action</label>
                </div>
                <div className="input-column">
                  <input
                    type="text"
                    className={`action-text-input ${
                      editValues?.selectedOption === "Sell" ? "Sell" : ""
                    }`}
                    id="action-txtInput"
                    value={editValues?.selectedOption}
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row pb-4">
            {editValues?.selectedPriceOption === "Stop Limit" && (
              <div className="action-column1">
                <div className="label-column">
                  <label htmlFor="action-txtInput">Stop Limit</label>
                </div>
                <div className="input-column">
                  <input
                    type="text"
                    className="details-text-input"
                    id="units-txtInput"
                    value={editValues?.stop}
                    disabled
                  />
                </div>
              </div>
            )}
            <div className="action-column2">
              <div className="label-column">
                <label htmlFor="action-txtInput">Quantity</label>
              </div>
              <div className="input-column">
                <input
                  type="text"
                  className="details-text-input"
                  id="units-txtInput"
                  value={editValues?.quantity}
                  disabled
                />
              </div>
            </div>
            {editValues?.selectedPriceOption !== "Market" && (
              <div className="action-column3">
                <div className="label-column">
                  <label htmlFor="action-txtInput">Order Price</label>
                </div>
                <div className="price-input-container">
                  <input
                    type="text"
                    className="price-text-input"
                    value="$"
                    disabled
                  />
                  <div className="input-column">
                    <input
                      type="text"
                      className="details-text-input"
                      id="action-txtInput"
                      value={editValues?.price || pairFees?.last_price}
                      disabled
                    />
                  </div>
                </div>
              </div>
            )}
            <div className="action-column4">
              <div className="label-column">
                <label htmlFor="action-txtInput">Type</label>
              </div>
              <div className="input-column">
                <input
                  type="text"
                  className="details-text-input"
                  id="action-txtInput"
                  value={editValues?.selectedPriceOption}
                  disabled
                />
              </div>
            </div>
            {/* <div className="action-column4">
              <div className="label-column">
                <label htmlFor="action-txtInput">Duration</label>
              </div>
              <div className="input-column">
                <input
                  type="text"
                  className="details-text-input"
                  id="action-txtInput"
                  value="Good for day"
                  disabled
                />
              </div>
            </div> */}
          </div>
          {editValues?.selectedPriceOption !== "Market" && (
            <div className="row pb-0">
              <div className="column col-6">
                <div className="estimated-column">
                  <div className="label-column">
                    <label htmlFor="action-txtInput">
                      Estimated commission
                    </label>
                  </div>
                  <div className="price-input-container">
                    <input
                      type="text"
                      className="details-text-input"
                      value={`$ ${formatCommaNumbers(
                        getTotalValue(
                          Number(editValues?.price || pairFees?.last_price),
                          Number(editValues?.quantity) *
                            (editValues?.selectedOption === "Buy"
                              ? pairFees?.trade_fee_buy
                              : pairFees?.trade_fee_sell)
                        ) / 100
                      )}`}
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div className="column col-6">
                <div className="estimated-column">
                  <div className="label-column">
                    <label htmlFor="action-txtInput">
                      Estimated total cost
                    </label>
                  </div>
                  <div className="price-input-container">
                    <input
                      type="text"
                      className="price-text-input"
                      value="$"
                      disabled
                    />
                    <div className="input-column">
                      <input
                        type="text"
                        className="details-text-input"
                        id="action-txtInput"
                        value={formatCommaNumbers(
                          Number(
                            getTotalValue(
                              Number(
                                editValues?.price || pairFees?.last_price || 0
                              ),
                              Number(editValues?.quantity || 0)
                            ) *
                              (1 +
                                (editValues?.selectedOption === "Buy"
                                  ? Number(pairFees?.trade_fee_buy || 0) / 100
                                  : -Number(pairFees?.trade_fee_sell || 0) /
                                    100))
                          ).toFixed(2)
                        )}
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </CMBox>

      <CMDisBox className="p-0 pt-3">
        <h3>Disclaimer</h3>

        <CMDisclaimer className="mt-2">
          <p>
            Before investing in music royalties, it's important to understand
            that the income generated from music royalties can be unpredictable
            and may fluctuate over time. The amount of royalties received is
            dependent on various factors such as the popularity of the music,
            the number of streams or sales, and the terms of the licensing
            agreements. Additionally, the music industry is constantly evolving
            and there is no guarantee that a particular song or artist will
            continue to generate substantial royalties in the future.
          </p>
          <p>
            Investing in music royalties carries a level of risk, and it's
            important to carefully research and consider all aspects of the
            investment before making a decision. It's recommended that you seek
            advice from a financial professional and/or legal counsel to fully
            understand the potential risks and benefits associated with
            investing in music royalties. By investing in music royalties, you
            acknowledge and accept these risks and limitations.
          </p>
        </CMDisclaimer>
      </CMDisBox>
      <CMOffer>
        <Button
          buttonType={BUTTON_TYPE_CLASSES.TextButton}
          color="blue"
          onClick={handlePrev}
          style={CMOfferButton}
          className="mobileButtonCenter"
        >
          &lt; Edit Order
        </Button>
        <Button onClick={createOrder} color="light-green" disabled={disabled}>
          Place Order
        </Button>
      </CMOffer>
    </div>
  );
};
export default ConfirmOrder;
